import * as React from "react";
import { cn } from "../../lib/utils";
import { Label } from "../Label/Label";


export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string | null;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, label, ...props }, ref) => {
  const accessibleName = props['aria-label'] ?? label ?? undefined;

  return (
    <div className="relative space-y-2 w-full">
      {label && <Label>{label}</Label>}

      <input
        type={type}
        aria-label={accessibleName}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 focus:border-primary focus:border-1 focus:ring-primary focus:ring-1 focus:ring-inset",
          className
        )}
        ref={ref}
        {...props}
      />
    </div>
  );
});
Input.displayName = "Input";

export { Input };
